import { Link, useLocation } from "react-router-dom";
import { Logo } from "./Dashboard/Logo";
import {
  Fragment,
  useContext,
  useLayoutEffect,
  useState,
  useEffect,
  useMemo,
} from "react";
import { contextApi } from "../context/contextApi";
import { getAssetTypes } from "../services/bags";
import { api } from "../services/config";
import { assetSlugToUrl } from "../utils/assetRoutes";
import { toPersianDigits } from "../utils/toPersianDigits";

const WALLET_MENU_ID = "wallet";

const walletRoutes = [
  ...Object.values(assetSlugToUrl),
  "/wallet-internet-gateway",
  "/wallet-rial-account",
  "/wallet-rial-check",
  "/wallet-rial-vip",
  "/wallet-card",
  "/wallet-gold-coin",
];

const staticMenuItems = [
  { linkName: "پیشخوان", id: 1, url: "/", icon: "/images/dashboard.png" },
  {
    linkName: "دریافت وجه به لینک",
    id: 7,
    url: "/ReceivePayment",
    icon: "/images/link.png",
  },
  {
    linkName: "گزارش لینک دریافت وجه",
    id: 8,
    url: "/Reports",
    icon: "/images/report.png",
  },
  {
    linkName: "ذینفع ها",
    id: 9,
    url: "/Beneficiary",
    icon: "/images/Beneficiary.png",
  },
  {
    linkName: "صورتحساب",
    id: 10,
    url: "/Bill",
    icon: "/images/bill.png",
  },
  {
    linkName: "تبدیل",
    id: 14,
    url: "/convert",
    icon: "/images/conversion.png",
  },
  { linkName: "دانلود اکسل", id: 12, url: "/help", icon: "/images/file.png" },
  {
    linkName: "پشتیبانی",
    id: 11,
    url: "/support",
    icon: "/images/center.png",
    badgeKey: "waiting_tickets",
  },
];

const MenuBadge = ({ count }) => {
  if (!count || count <= 0) return null;
  return (
    <span className="menu-badge shrink-0 inline-flex items-center justify-center min-w-[22px] h-[22px] px-1.5 rounded-full bg-red-600 text-white text-[11px] font-bold leading-none">
      {toPersianDigits(count)}
    </span>
  );
};

export const SideBar = () => {
  const context = useContext(contextApi);
  const [openSubmenus, setOpenSubmenus] = useState({});
  const [assetTypes, setAssetTypes] = useState([]);
  const [menuStats, setMenuStats] = useState({
    waiting_tickets: 0,
  });

  const menuItems = useMemo(() => {
    const walletMenu = {
      linkName: "کیف پول",
      id: WALLET_MENU_ID,
      hasSubmenu: true,
      icon: "/images/wallet-curency.png",
      submenu: assetTypes.map((asset) => ({
        linkName: asset.title,
        id: `asset-${asset.type}`,
        url: assetSlugToUrl[asset.slug] ?? "/",
        type: asset.type,
        icon: asset.icon,
      })),
    };

    return [staticMenuItems[0], walletMenu, ...staticMenuItems.slice(1)];
  }, [assetTypes]);

  useLayoutEffect(() => {
    function updateSize() {
      context.setMenu(false);
    }
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, [context]);

  const route = useLocation();
  const currentType = new URLSearchParams(route.search).get("type");

  useEffect(() => {
    setOpenSubmenus((prev) => {
      const newState = { ...prev };
      if (walletRoutes.includes(route.pathname)) {
        newState[WALLET_MENU_ID] = true;
      }
      return newState;
    });
  }, [route.pathname]);

  useEffect(() => {
    const loadAssetTypes = async () => {
      try {
        const response = await getAssetTypes();
        setAssetTypes(response?.data?.data ?? []);
      } catch (error) {
        console.error(error);
        setAssetTypes([]);
      }
    };

    loadAssetTypes();
  }, []);

  useEffect(() => {
    const getOpenMenuCount = async () => {
      try {
        const response = await api.get("menu-stats", {
          headers: {
            authorization: `Bearer ${localStorage.getItem("login")}`,
          },
        });
        const data = response.data?.data || {};
        setMenuStats({
          waiting_tickets: data.waiting_tickets ?? 0,
        });
      } catch (error) {
        console.log(error);
      }
    };

    getOpenMenuCount();
  }, [route.pathname]);

  const getBadgeCount = (badgeKey) => {
    if (!badgeKey) return 0;
    return menuStats[badgeKey] ?? 0;
  };

  return (
    <Fragment>
      <div
        className={`fixed overlay left-0 top-0 bg-black opacity-50 w-full h-full z-50 ${
          context.menu ? "block" : "hidden"
        }`}
        onClick={() => context.setMenu(false)}
      ></div>
      <div className={` h-full side-bar ${context.menu ? "active" : ""}`}>
        <button
          className="close-menu-btn md:hidden absolute top-4 left-4 w-8 h-8 flex items-center justify-center rounded-full bg-gray-700 hover:bg-gray-600 text-white transition-all duration-300 z-10"
          onClick={() => context.setMenu(false)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <Logo src="/images/logo.png" class="logo" />
        <ul className="parent-links pb-8 pt-1 mx-10 md:mx-2 ">
          {menuItems.map((item) => {
            if (item.hasSubmenu) {
              const isOpen = openSubmenus[item.id] || false;
              return (
                <div key={item.id}>
                  <div
                    className="items-center link-parent flex cursor-pointer w-full"
                    onClick={() =>
                      setOpenSubmenus((prev) => ({
                        ...prev,
                        [item.id]: !prev[item.id],
                      }))
                    }
                  >
                    {item.icon ? (
                      <img
                        src={item.icon}
                        className="inline shrink-0"
                        width={25}
                        alt=""
                      />
                    ) : (
                      <svg
                        className="inline shrink-0"
                        width="25"
                        height="25"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3 8V6C3 4.89543 3.89543 4 5 4H9.58579C9.851 4 10.1054 4.10536 10.2929 4.29289L12.7071 6.70711C12.8946 6.89464 13.149 7 13.4142 7H19C20.1046 7 21 7.89543 21 9V18C21 19.1046 20.1046 20 19 20H5C3.89543 20 3 19.1046 3 18V8Z"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    )}
                    <li
                      className={`links py-2 text-gray-500 mr-10 md:mr-5 flex-1 min-w-0 text-xs md:text-sm`}
                    >
                      <span>{item.linkName}</span>
                    </li>
                    <span className="submenu-chevron shrink-0 w-5 text-center text-xs leading-none">
                      {isOpen ? "▲" : "▼"}
                    </span>
                  </div>
                  {isOpen && item.submenu?.length > 0 && (
                    <ul className="mr-8 mt-2">
                      {item.submenu.map((subItem) => (
                        <Link
                          to={`${subItem.url}?type=${subItem.type}`}
                          key={subItem.id}
                          className={`items-center link-parent flex ${
                            route.pathname === subItem.url &&
                            currentType === String(subItem.type)
                              ? "active"
                              : ""
                          }`}
                          onClick={() => context.setMenu(false)}
                        >
                          <img
                            src={subItem.icon}
                            className="inline"
                            width={20}
                            alt=""
                          />
                          <li
                            className={`links py-2 text-gray-500 mr-10 md:mr-5 w-full text-xs md:text-sm ${
                              route.pathname === subItem.url &&
                              currentType === String(subItem.type)
                                ? "active"
                                : ""
                            }`}
                          >
                            <span>{subItem.linkName}</span>
                          </li>
                        </Link>
                      ))}
                    </ul>
                  )}
                </div>
              );
            }
            return (
              <Link
                to={item.url}
                key={item.id}
                className={`items-center link-parent flex ${
                  item.url === route.pathname ? "active" : ""
                }`}
                onClick={() => context.setMenu(false)}
              >
                <img src={item.icon} className="inline shrink-0" width={25} alt="" />
                <li
                  className={`links py-2 text-gray-500 mr-10 md:mr-5 w-full text-xs md:text-sm ${
                    item.url === route.pathname ? "active" : ""
                  }`}
                >
                  <span className="flex w-full items-center justify-between gap-2">
                    <span>{item.linkName}</span>
                    <MenuBadge count={getBadgeCount(item.badgeKey)} />
                  </span>
                </li>
              </Link>
            );
          })}
        </ul>
      </div>
    </Fragment>
  );
};
